var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSellerAuto = exports.isSeller = exports.isFirstChat = exports.isBuyerAuto = exports.isBuyer = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsWeb = require("@olxbr/ds-web");
var _olxIcons = require("@olxbr/olx-icons");
var _dsSpots = require("@olxbr/ds-spots");
var _chatModReactComponentsWeb = require("@olxbr/chat-mod-react-components-web");
var _urls = require("../../helpers/urls");
var Lurker = _interopRequireWildcard(require("../../helpers/lurker"));
var _jsxRuntime = require("react/jsx-runtime");
var _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/tips/src/components/FirstTip/tipTexts.js",
  _this = this;
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var clickOpenLink = function clickOpenLink(link) {
  Lurker.clickOpenLinkModal({
    link: link
  });
  window.open(link, '_blank');
};
var CircleIcon = (0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
  interactive: false,
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.MessageCircle, {
    color: "var(--color-secondary-120)"
  }),
  bgColor: "--color-neutral-80",
  marginRight: "--spacing-1"
});
var UserIcon = (0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
  interactive: false,
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.Users, {
    color: "var(--color-secondary-120)"
  }),
  bgColor: "--color-neutral-80",
  marginRight: "--spacing-1"
});
var MailIcon = (0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
  interactive: false,
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.Mail, {
    color: "var(--color-secondary-120)"
  }),
  bgColor: "--color-neutral-80",
  marginRight: "--spacing-1"
});
var PackageIcon = (0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
  interactive: false,
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.Package, {
    color: "var(--color-secondary-120)"
  }),
  bgColor: "--color-neutral-80",
  marginRight: "--spacing-1"
});
var isFirstChat = {
  id: 'isFirstChat',
  icon: (0, _jsxRuntime.jsx)(_olxIcons.System.MessageCircle, {}),
  titleTip: 'Boas-vindas ao chat da OLX',
  description: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
    isMobile: true,
    children: [(0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
      isMobile: true,
      weight: "bold",
      children: "Boas-vindas ao chat da OLX"
    }), "Re\xFAna a sua negocia\xE7\xE3o aqui, facilitando a conversa e aumentando sua prote\xE7\xE3o."]
  }),
  linkText: 'Como o chat ajuda minha proteção?',
  link: _urls.URL_ENTENDA_CHAT
};
exports.isFirstChat = isFirstChat;
var isSeller = function isSeller(isMobile) {
  return {
    id: 'isSeller',
    icon: (0, _jsxRuntime.jsx)(_olxIcons.System.HelpCircle, {}),
    description: 'Mantenha a negociação no chat e aumente sua proteção contra fraudes.',
    linkText: 'Vendendo na OLX com segurança',
    title: 'Vendendo com segurança',
    items: [{
      id: '1',
      icon: CircleIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "inline",
        children: [(0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          weight: "bold",
          display: "inline",
          children: "Sempre mantenha"
        }), "\xA0a negocia\xE7\xE3o no chat e n\xE3o envie ou pe\xE7a telefones ou email."]
      })
    }, {
      id: '2',
      icon: MailIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "inline",
        children: ["A OLX\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          weight: "bold",
          display: "inline",
          children: "nunca"
        }), "\xA0envia comprovantes ou dados de venda por email ou whatsapp."]
      })
    }, {
      id: '3',
      icon: UserIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "inline",
        children: ["Atendentes ou representantes da OLX\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          weight: "bold",
          display: "inline",
          children: "nunca"
        }), "\xA0utilizam o chat ou whatsapp."]
      })
    }, {
      id: '4',
      icon: PackageIcon,
      text: (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          display: "inline",
          children: ["Ao vender com a Garantia da OLX, s\xF3 utilize as informa\xE7\xF5es de envio do produto exibidas em\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.LinkButton, {
            onClick: function onClick() {
              return clickOpenLink(_urls.URL_DETALHES_VENDA);
            },
            display: "inline",
            isMobile: isMobile,
            children: "detalhes da venda."
          })]
        })
      })
    }]
  };
};
exports.isSeller = isSeller;
var isBuyer = function isBuyer(isMobile) {
  return {
    id: 'isBuyer',
    icon: (0, _jsxRuntime.jsx)(_olxIcons.System.HelpCircle, {}),
    description: 'Não envie informações de contato para vendedores para ter mais segurança.',
    linkText: 'Comprando na OLX com segurança',
    title: 'Comprando com segurança',
    items: [{
      id: '1',
      icon: CircleIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "inline",
        children: [(0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          weight: "bold",
          display: "inline",
          children: "Sempre mantenha"
        }), "\xA0a negocia\xE7\xE3o no chat e n\xE3o envie ou pe\xE7a telefones ou email."]
      })
    }, {
      id: '2',
      icon: MailIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "inline",
        children: ["Pague apenas ap\xF3s receber o produto em m\xE3os, ou quando utilizar a\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.LinkButton, {
          onClick: function onClick() {
            return clickOpenLink(_urls.URL_COMPRA_SEGURA);
          },
          isMobile: isMobile,
          display: "inline",
          children: "Garantia da OLX."
        })]
      })
    }, {
      id: '3',
      icon: UserIcon,
      text: (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "inline",
        children: "Confira os dados de seguran\xE7a no perfil do vendedor e seu hist\xF3rico de vendas."
      })
    }, {
      id: '4',
      icon: PackageIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "inline",
        children: ["A OLX\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          weight: "bold",
          display: "inline",
          children: "nunca"
        }), "\xA0envia pedidos de pagamento de produto por email ou celular."]
      })
    }]
  };
};
exports.isBuyer = isBuyer;
var isSellerAuto = function isSellerAuto(isMobile) {
  return {
    id: 'isSellerAuto',
    icon: (0, _jsxRuntime.jsx)(_olxIcons.Category.VeiculosEAcessorios, {}),
    description: 'Desconfie de terceiros na venda e negocie apenas com o comprador.',
    linkText: 'Venda veículos com segurança',
    title: 'Vendendo veículos com segurança',
    items: [{
      id: '1',
      icon: (0, _jsxRuntime.jsx)("div", {
        width: "56",
        children: (0, _jsxRuntime.jsx)(_dsSpots.Profile, {
          shape: "circle",
          size: "56"
        })
      }),
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "block",
        marginLeft: "--spacing-2",
        children: [(0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          weight: "bold",
          marginBottom: "--spacing-0-5",
          children: "A pessoa fala em nome de outra ou h\xE1 sigilo de valores?"
        }), (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          display: "inline",
          children: ["Alguns fraudadores agem assim.\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.LinkButton, {
            onClick: function onClick() {
              return clickOpenLink(_urls.URL_GOLPE_INTERMEDIARIO);
            },
            isMobile: isMobile,
            display: "inline",
            children: "Entenda essa abordagem."
          })]
        })]
      })
    }, {
      id: '2',
      icon: (0, _jsxRuntime.jsx)("div", {
        width: "56",
        children: (0, _jsxRuntime.jsx)(_dsSpots.Form, {
          shape: "circle",
          size: "56"
        })
      }),
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "block",
        marginLeft: "--spacing-2",
        children: [(0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          weight: "bold",
          marginBottom: "--spacing-0-5",
          children: "Te perguntaram sobre a documenta\xE7\xE3o?"
        }), "Nunca envie fotos de certificados ou documenta\xE7\xE3o, apenas mande os n\xFAmeros para consultas."]
      })
    }]
  };
};
exports.isSellerAuto = isSellerAuto;
var isBuyerAuto = function isBuyerAuto(isMobile) {
  return {
    id: 'isBuyerAuto',
    icon: (0, _jsxRuntime.jsx)(_olxIcons.Category.VeiculosEAcessorios, {}),
    description: 'Sempre solicite dados do veículo no chat e desconfie de sigilos de valores.',
    linkText: 'Compre veículos com segurança',
    title: 'Comprando veículos com segurança',
    items: [{
      id: '1',
      icon: (0, _jsxRuntime.jsx)("div", {
        width: "56",
        children: (0, _jsxRuntime.jsx)(_dsSpots.Profile, {
          shape: "circle",
          size: "56"
        })
      }),
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "block",
        marginLeft: "--spacing-2",
        children: [(0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          weight: "bold",
          marginBottom: "--spacing-0-5",
          children: "A pessoa fala em nome de outra ou h\xE1 sigilo de valores?"
        }), (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          display: "inline",
          children: ["Alguns fraudadores agem assim.\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.LinkButton, {
            onClick: function onClick() {
              return clickOpenLink(_urls.URL_GOLPE_INTERMEDIARIO);
            },
            isMobile: isMobile,
            display: "inline",
            children: "Entenda essa abordagem."
          })]
        })]
      })
    }, {
      id: '2',
      icon: (0, _jsxRuntime.jsx)("div", {
        width: "56",
        children: (0, _jsxRuntime.jsx)(_dsSpots.PixFeedbackError, {
          shape: "circle",
          size: "56"
        })
      }),
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMobile,
        display: "block",
        marginLeft: "--spacing-2",
        children: [(0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMobile,
          weight: "bold",
          marginBottom: "--spacing-0-5",
          children: "Solicitaram pagamento na conta de terceiro?"
        }), "Prefira somente ao(a) propriet\xE1rio(a) do ve\xEDculo ou com procura\xE7\xE3o."]
      })
    }]
  };
};
exports.isBuyerAuto = isBuyerAuto;